import { Box, Tabs } from '@tf/ui';
import type React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

export const InternalToolsLayout: React.FC = () => {
	const navigate = useNavigate();

	const tabs = [
		{ href: '/internal-tools/enums', title: 'Enums' },
		{ href: '/internal-tools/structs', title: 'Structs' },
		{ href: '/internal-tools/export', title: 'Export' },
		{ href: '/internal-tools/import', title: 'Import' },
	];

	const selectedTab = tabs.find((t) => window.location.pathname.includes(t.href))?.href ?? '';

	return (
		<Box mt="20px">
			<Tabs
				mb="12px"
				value={selectedTab}
				onChange={(path) => {
					if (path) {
						navigate(path);
					}
				}}
			>
				<Tabs.List>
					{tabs.map(({ href, title }) => (
						<Tabs.Tab key={href} value={href}>
							{title}
						</Tabs.Tab>
					))}
				</Tabs.List>
			</Tabs>

			<Outlet />
		</Box>
	);
};
